module.exports = __webpack_public_path__ + "img/figure7.3af1492e.png";